"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDraggingParameterSettings = exports.validateGumballParameterSettings = exports.validateSelectionParameterSettings = exports.validateInteractionParameterSettings = exports.IInteractionParameterJsonSchema = exports.IDraggingParameterJsonSchema = exports.IDraggingParameterPropsJsonSchema = exports.IGumballParameterJsonSchema = exports.IGumballParameterPropsJsonSchema = exports.ISelectionParameterJsonSchema = exports.ISelectionParameterPropsJsonSchema = void 0;
const zod_1 = require("zod");
// #endregion Interfaces (2)
// #region Variables (7)
const optionalBoolean = zod_1.z.preprocess((val) => {
    if (val === "true")
        return true;
    if (val === "false")
        return false;
    if (val === null)
        return undefined;
    return val;
}, zod_1.z.boolean().optional());
const interactionEffectSchema = zod_1.z
    .union([zod_1.z.string(), zod_1.z.object({}).passthrough()])
    .nullable();
const IGeneralInteractionParameterJsonSchema = zod_1.z.object({
    hover: optionalBoolean,
    hoverColor: interactionEffectSchema.optional(),
    prompt: zod_1.z
        .object({
        inactiveTitle: zod_1.z.string().nullable().optional(),
        activeTitle: zod_1.z.string().nullable().optional(),
        activeText: zod_1.z.string().nullable().optional(),
    })
        .nullable()
        .optional(),
});
exports.ISelectionParameterPropsJsonSchema = zod_1.z
    .object({
    maximumSelection: zod_1.z.number().nullable().optional(),
    minimumSelection: zod_1.z.number().nullable().optional(),
    nameFilter: zod_1.z.array(zod_1.z.string()).nullable().optional(),
    selectionColor: interactionEffectSchema.optional(),
    availableColor: interactionEffectSchema.optional(),
    deselectOnEmpty: optionalBoolean,
})
    .merge(IGeneralInteractionParameterJsonSchema);
exports.ISelectionParameterJsonSchema = zod_1.z.object({
    type: zod_1.z.literal("selection"),
    props: exports.ISelectionParameterPropsJsonSchema,
});
exports.IGumballParameterPropsJsonSchema = zod_1.z
    .object({
    enableRotation: optionalBoolean,
    enableRotationAxes: zod_1.z
        .object({
        x: optionalBoolean,
        y: optionalBoolean,
        z: optionalBoolean,
        xy: optionalBoolean,
        yz: optionalBoolean,
        xz: optionalBoolean,
    })
        .nullable()
        .optional(),
    enableScaling: optionalBoolean,
    enableScalingAxes: zod_1.z
        .object({
        x: optionalBoolean,
        y: optionalBoolean,
        z: optionalBoolean,
        xy: optionalBoolean,
        yz: optionalBoolean,
        xz: optionalBoolean,
    })
        .nullable()
        .optional(),
    enableTranslation: optionalBoolean,
    enableTranslationAxes: zod_1.z
        .object({
        x: optionalBoolean,
        y: optionalBoolean,
        z: optionalBoolean,
        xy: optionalBoolean,
        yz: optionalBoolean,
        xz: optionalBoolean,
    })
        .nullable()
        .optional(),
    nameFilter: zod_1.z.array(zod_1.z.string()).nullable().optional(),
    scale: zod_1.z.number().nullable().optional(),
    space: zod_1.z.literal("local").or(zod_1.z.literal("world")).nullable().optional(),
    selectionColor: interactionEffectSchema.optional(),
    availableColor: interactionEffectSchema.optional(),
    maximumSelection: zod_1.z.number().nullable().optional(),
    minimumSelection: zod_1.z.number().nullable().optional(),
    deselectOnEmpty: optionalBoolean,
    objects: zod_1.z
        .array(zod_1.z.object({
        nameFilter: zod_1.z.string(),
        restrictions: zod_1.z.array(zod_1.z.string()),
    }))
        .nullable()
        .optional(),
    restrictions: zod_1.z
        .array(zod_1.z
        .object({
        id: zod_1.z.string(),
        type: zod_1.z.string(),
        rotation: zod_1.z
            .object({
            axis: zod_1.z.array(zod_1.z.number()),
            angle: zod_1.z.number(),
        })
            .nullable()
            .optional(),
    })
        .passthrough())
        .nullable()
        .optional(),
})
    .merge(IGeneralInteractionParameterJsonSchema);
exports.IGumballParameterJsonSchema = zod_1.z.object({
    type: zod_1.z.literal("gumball"),
    props: exports.IGumballParameterPropsJsonSchema,
});
exports.IDraggingParameterPropsJsonSchema = zod_1.z
    .object({
    draggingColor: interactionEffectSchema.optional(),
    availableColor: interactionEffectSchema.optional(),
    objects: zod_1.z
        .array(zod_1.z.object({
        nameFilter: zod_1.z.string(),
        restrictions: zod_1.z.array(zod_1.z.string()),
        dragAnchors: zod_1.z
            .array(zod_1.z.object({
            id: zod_1.z.string(),
            position: zod_1.z.array(zod_1.z.number()),
            rotation: zod_1.z
                .object({
                axis: zod_1.z.array(zod_1.z.number()),
                angle: zod_1.z.number(),
            })
                .nullable()
                .optional(),
        }))
            .nullable()
            .optional(),
        dragOrigin: zod_1.z.array(zod_1.z.number()).nullable().optional(),
    }))
        .nullable()
        .optional(),
    restrictions: zod_1.z
        .array(zod_1.z
        .object({
        id: zod_1.z.string(),
        type: zod_1.z.string(),
        rotation: zod_1.z
            .object({
            axis: zod_1.z.array(zod_1.z.number()),
            angle: zod_1.z.number(),
        })
            .nullable()
            .optional(),
    })
        .passthrough())
        .nullable()
        .optional(),
})
    .merge(IGeneralInteractionParameterJsonSchema);
exports.IDraggingParameterJsonSchema = zod_1.z.object({
    type: zod_1.z.literal("dragging"),
    props: exports.IDraggingParameterPropsJsonSchema,
});
exports.IInteractionParameterJsonSchema = exports.ISelectionParameterJsonSchema.or(exports.IGumballParameterJsonSchema).or(exports.IDraggingParameterJsonSchema);
const validateInteractionParameterSettings = (param) => {
    return exports.IInteractionParameterJsonSchema.safeParse(param);
};
exports.validateInteractionParameterSettings = validateInteractionParameterSettings;
const validateSelectionParameterSettings = (param) => {
    return exports.ISelectionParameterJsonSchema.safeParse(param);
};
exports.validateSelectionParameterSettings = validateSelectionParameterSettings;
const validateGumballParameterSettings = (param) => {
    return exports.IGumballParameterJsonSchema.safeParse(param);
};
exports.validateGumballParameterSettings = validateGumballParameterSettings;
const validateDraggingParameterSettings = (param) => {
    return exports.IDraggingParameterJsonSchema.safeParse(param);
};
exports.validateDraggingParameterSettings = validateDraggingParameterSettings;
// #endregion Variables (7)
//# sourceMappingURL=IInteractionParameterSettings.js.map